import React from 'react';

export const ChevronLeft = () => (
    <polyline points='15 6 9 12 15 18' />
);